"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Creator = void 0;
var Creator = (function () {
    function Creator() {
    }
    Creator.getAttributeTypeMap = function () {
        return Creator.attributeTypeMap;
    };
    Creator.discriminator = undefined;
    Creator.attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastName",
            "baseName": "last_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstName",
            "baseName": "first_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastNameKana",
            "baseName": "last_name_kana",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstNameKana",
            "baseName": "first_name_kana",
            "type": "string",
            "format": ""
        },
        {
            "name": "birthdate",
            "baseName": "birthdate",
            "type": "string",
            "format": ""
        },
        {
            "name": "age",
            "baseName": "age",
            "type": "number",
            "format": ""
        },
        {
            "name": "postcode",
            "baseName": "postcode",
            "type": "string",
            "format": ""
        },
        {
            "name": "address",
            "baseName": "address",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "gender",
            "baseName": "gender",
            "type": "string",
            "format": ""
        },
        {
            "name": "phoneNumber",
            "baseName": "phone_number",
            "type": "string",
            "format": ""
        },
        {
            "name": "emergencyPhoneNumber",
            "baseName": "emergency_phone_number",
            "type": "string",
            "format": ""
        },
        {
            "name": "parentLastName",
            "baseName": "parent_last_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "parentFirstName",
            "baseName": "parent_first_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "parentRelationship",
            "baseName": "parent_relationship",
            "type": "CreatorParentRelationshipEnum",
            "format": ""
        },
        {
            "name": "parentPhoneNumber",
            "baseName": "parent_phone_number",
            "type": "string",
            "format": ""
        },
        {
            "name": "creatorType",
            "baseName": "creator_type",
            "type": "CreatorCreatorTypeEnum",
            "format": ""
        },
        {
            "name": "availableServices",
            "baseName": "available_services",
            "type": "Array<CreatorAvailableServicesEnum>",
            "format": ""
        },
        {
            "name": "imageUrl",
            "baseName": "image_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "hasChannelJoiningMcn",
            "baseName": "has_channel_joining_mcn",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isLiveStreamingCreator",
            "baseName": "is_live_streaming_creator",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isVoomCreator",
            "baseName": "is_voom_creator",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isVoomTermsViewed",
            "baseName": "is_voom_terms_viewed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isRevenueViewed",
            "baseName": "is_revenue_viewed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isMcnJoinCreator",
            "baseName": "is_mcn_join_creator",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isNetworkCreator",
            "baseName": "is_network_creator",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "creatorAppearInAdSurveys",
            "baseName": "creator_appear_in_ad_surveys",
            "type": "Array<CreatorCreatorAppearInAdSurveys>",
            "format": ""
        }
    ];
    return Creator;
}());
exports.Creator = Creator;
//# sourceMappingURL=Creator.js.map